import { Button, Icon, Input, Spin, Table, Empty } from "antd";
import i18next from "i18next";
import React, { Component } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { SystemConfigService } from "../../services/systemConfig/SystemConfigService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import AddConfig from "./AddConfig";
import EditConfig from "./EditConfig";
import "./SystemConfig.css";
import { Translation } from "react-i18next";

class SystemConfig extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("system");
    this.systemConfigService = new SystemConfigService();
    this.state = {
      isFetching: false,
      searchText: "",
      visible: false,
      configKey: "",
      configValue: "",
      configCategory: "",
      data: [],
      visibleAdd: false,
    };
  }

  showEditModal = (record) => {
    this.setState({
      visible: true,
      configKey: record.configKey,
      configValue: record.configValue,
      configCategory: record.configCategory,
    });
  };

  handleCancelEdit = (e) => {
    this.setState({
      visible: false,
    });
  };

  showAddModal = () => {
    this.setState({
      visibleAdd: true,
    });
  };

  handleCancelAdd = (e) => {
    this.setState({
      visibleAdd: false,
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <Translation>
        {(t) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={(node) => {
                this.searchInput = node;
              }}
              placeholder={i18next.t(`Search ${dataIndex}`)}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm)}
              icon="search"
              size="small"
              style={
                this.props.context.curr_dir === "ltr" &&
                this.props.context.curr_lang === "en"
                  ? { width: 100, marginRight: 8 }
                  : { width: 100, marginLeft: 8 }
              }
            >
              {t("Search")}
            </Button>
            <Button
              onClick={() => this.handleReset(clearFilters)}
              size="small"
              style={{ width: 80 }}
            >
              {t("Reset")}
            </Button>
          </div>
        )}
      </Translation>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidMount() {
    this.getAllSystemConfigs();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllSystemConfigs() {
    try {
      this.setState({ isFetching: true });
      let data = await this.systemConfigService.getAllSystemConfigService(
        this.props.context.session_id
      );

      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["configKey"] = data.ivrList[i]["key"];
      row["configValue"] = data.ivrList[i]["value"];
      row["configCategory"] = data.ivrList[i]["configCategory"];
      row["editable"] = data.ivrList[i]["editable"];
      if (row["configKey"] === "MSISDN_TYPE") {
        this.props.context.user.msisdnType = row["configValue"];
      }
      updated_data.push(row);
    }
    return updated_data;
  }

  render() {
    const columns = [
      {
        title: i18next.t("Key"),
        dataIndex: "configKey",
        key: "configKey",
        width: "30%",
        ...this.getColumnSearchProps("configKey"),
      },
      {
        title: i18next.t("Value"),
        dataIndex: "configValue",
        key: "configValue",
        width: "40%",
        ...this.getColumnSearchProps("configValue"),
        render: (text, record) => {
          if (record.configKey == "INV_TTL") {
            return `${text} days`;
          }
          return text;
        },
      },
      {
        title: i18next.t("Config Category"),
        dataIndex: "configCategory",
        key: "configCategory",
        width: "20%",
        ...this.getColumnSearchProps("configCategory"),
      },
      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1 && record.editable ? (
            <Button
              icon="edit"
              className="button-open-modal"
              onClick={() => this.showEditModal(record)}
            >
              {i18next.t("Edit")}
            </Button>
          ) : null,
      },
    ];

    let { isFetching } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page title={t("System Properties")}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Table
                  columns={columns}
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "25px",
                  }}
                  dataSource={this.state.data}
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  bordered
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />

                <EditConfig
                  visible={this.state.visible}
                  onCancel={() => this.handleCancelEdit()}
                  Key={this.state.configKey}
                  value={this.state.configValue}
                  configCategory={this.state.configCategory}
                  getAllSystemConfigs={() => this.getAllSystemConfigs()}
                />
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(SystemConfig);
